export * from './branchscancode.component';


// WEBPACK FOOTER //
// /var/www/html/foodbot_stage/web/src/app/branchscancode/index.ts